<div class="border-l-4 border-laureate-500 pt-2 px-6">
    <h1 class="font-semibold text-3xl mb-4">{{ title | uppercase }}</h1>
    <p>{{ description }}</p>
</div>